import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHeartbeat = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		strokeLinecap: "round",
		strokeWidth: 1.5,
		stroke: "currentColor",
		fill: "none",
		strokeLinejoin: "round",
		children: [/* @__PURE__ */ _jsx("path", { d: "M17,21h-10" }), /* @__PURE__ */ _jsx("path", { d: "M4,6v-1c0,-1.105 0.895,-2 2,-2h12c1.105,0 2,0.895 2,2v5h-4l-2.4,-3.28l-3.2,6.56l-2.4,-3.28h-4c0,0.91 0,4.002 0,5c0,1.105 0.895,2 1.999,2c3.074,0 8.928,0 12.002,0c1.104,0 1.999,-0.895 1.999,-2v-1" })]
	}), /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M0,0h24v24h-24Z"
	})]
});
export default SvgHeartbeat;
